module.exports = __webpack_public_path__ + "static/media/curriculumKit__smartHome.17988b4b.svg";